module.exports = __webpack_public_path__ + "static/media/fibre_optics.9687fedc.jpg";